module.exports = __webpack_public_path__ + "media/images/redesign-images/home/design-flatlays/design-5-f0f6021fe2ab9d240c1b716f1c41d57c.png";